/* ============================================================
   RDP GAME ENGINE — wallet, crates, cart drawer, wishlist
   Reads config from window.RDP (set by the crates section).
   Vanilla JS, no dependencies. Uses localStorage (works on
   the live site; mock previews fall back to memory).
============================================================ */
(function(){
  var CFG;

  function init(){
    if(window.__rdpInit) return;
    window.__rdpInit = true;
    CFG = Object.assign({startSpins:0,prizes:[],moneyFmt:'$',reelImages:[]}, window.RDP||{});

  /* ---------- safe storage ---------- */
  var store = (function(){
    try{ localStorage.setItem('__t','1'); localStorage.removeItem('__t'); return localStorage; }
    catch(e){ var m={}; return {getItem:function(k){return k in m?m[k]:null;},setItem:function(k,v){m[k]=String(v);},removeItem:function(k){delete m[k];}}; }
  })();
  function today(){ return new Date().toISOString().slice(0,10); }
  function $(id){ return document.getElementById(id); }
  function fmt(n){ return CFG.moneyFmt + n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }

  /* ---------- toast ---------- */
  var toastTimer;
  var ACH = ['New Item Acquired', 'Achievement Unlocked', 'Rare Drop', 'Item Added', 'Inventory +1'];
  function toast(icon, text){
    var t = $('rdpToast'); if(!t) return;
    $('rdpToastIcon').textContent = icon;
    $('rdpToastText').textContent = text;
    $('rdpToastTitle').textContent = ACH[Math.floor(Math.random()*ACH.length)];
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 2200);
  }

  /* ---------- keys + pulls (replaces bucks wallet) ---------- */
  var keys = CFG.startSpins|0;
  try{ var kv = store.getItem('rdpSpins'); if(kv!==null) keys = parseInt(kv,10)||0; }catch(e){}
  if((CFG.forceKeys|0) > 0){ keys = CFG.forceKeys|0; try{ store.setItem('rdpSpins', String(keys)); }catch(e){} }
  function saveKeys(){ try{ store.setItem('rdpSpins', String(keys)); }catch(e){} }
  var pulls = [];
  try{ var pv = store.getItem('rdpPulls'); if(pv) pulls = JSON.parse(pv)||[]; }catch(e){ pulls = []; }
  function savePulls(){ try{ store.setItem('rdpPulls', JSON.stringify(pulls.slice(0,40))); }catch(e){} }
  function keyLabel(n){ return n + (n===1?' key':' keys'); }
  function rarityColor(r){ return ({consumer:'#b0c3d9',milspec:'#4b69ff',restricted:'#8847ff',classified:'#d32ce6',covert:'#eb4b4b',gold:'#e4ae39'})[r]||'#a4d007'; }
  function renderPulls(){
    var box=$('rdpPulls'); if(!box) return;
    if(!pulls.length){ box.innerHTML='<div class="wp-row" style="opacity:.55;"><span class="l">no pulls yet — open a crate</span></div>'; return; }
    box.innerHTML = pulls.map(function(p){
      var vis=(p.emoji?p.emoji+' ':'')+p.label+(p.code?' · '+p.code:'');
      var col=(p.rarity==='gold')?'#e4ae39':'#a4d007';
      return '<div class="wp-row"><span class="l">'+vis+'</span>'+(p.code?'<span class="a pos" data-code="'+p.code+'" style="cursor:pointer;color:'+col+';">copy</span>':'')+'</div>';
    }).join('');
  }
  function addPull(p){ pulls.unshift({label:p.label,code:p.code,emoji:p.emoji,rarity:p.rarity}); savePulls(); renderPulls(); }
  function renderSpins(){
    var lbl = keyLabel(keys);
    var a=$('rdpKeyAmt'); if(a) a.textContent = lbl;
    var h=$('rdpWalletAmt'); if(h) h.textContent = String(keys);
    var c=$('rdpCrateSpins'); if(c) c.textContent = keys>0 ? ('you have '+lbl) : 'no keys yet — earn one by signing the guestbook';
    renderPulls();
  }
  function grantKey(n, dedupe){
    n = n||1;
    if(dedupe){ var gk='rdpKeyGrant_'+dedupe; try{ if(store.getItem(gk)) return false; store.setItem(gk,'1'); }catch(e){} }
    keys += n; saveKeys(); renderSpins();
    toast('🔑', keyLabel(n)+' earned');
    return true;
  }
  window.rdpGrantSpin = grantKey; window.rdpGrantKey = grantKey;
  window.rdpEarn = function(){}; window.rdpCappedEarn = function(){};
  var panel = $('rdpWalletPanel'), pill = $('rdpWalletBtn');
  if(pill && panel){
    pill.addEventListener('click', function(e){ e.stopPropagation(); panel.classList.toggle('open'); });
    document.addEventListener('click', function(e){
      if(panel.classList.contains('open') && !panel.contains(e.target) && e.target!==pill) panel.classList.remove('open');
    });
  }
  var kclose=$('rdpKeyClose');
  if(kclose && panel){ kclose.addEventListener('click', function(e){ e.stopPropagation(); panel.classList.remove('open'); }); }
  var pullsBox=$('rdpPulls');
  if(pullsBox){
    pullsBox.addEventListener('click', function(e){
      var t=e.target.closest('[data-code]'); if(!t) return;
      var code=t.getAttribute('data-code');
      try{ navigator.clipboard.writeText(code); }catch(err){}
      toast('📋','copied '+code);
    });
  }

  /* ---------- crates (real prize codes) ---------- */
  var PRIZES = (CFG.prizes && CFG.prizes.length) ? CFG.prizes : [{label:'10% OFF',code:'',odds:1,rarity:'milspec',redeem:'',emoji:'💵',image:''}];
  function pickPrize(){
    var total = PRIZES.reduce(function(s,p){return s+(p.odds||0);},0) || PRIZES.length;
    var r = Math.random()*total;
    for(var i=0;i<PRIZES.length;i++){ if((r -= (PRIZES[i].odds||0)) < 0) return PRIZES[i]; }
    return PRIZES[0];
  }
  var spinning = false, crateBtn = $('rdpCrateOpen'), panelBtn = $('rdpPanelOpen');
  function refreshCrateBtns(){
    var open = keys>0 && !spinning;
    if(crateBtn){ crateBtn.disabled = !open; crateBtn.textContent = (keys>0) ? ('open crate ('+keys+')') : 'earn a key first'; }
    if(panelBtn){ panelBtn.disabled = !open; panelBtn.textContent = (keys>0) ? 'open a crate' : 'earn a key first'; }
  }
  setInterval(refreshCrateBtns, 300); refreshCrateBtns();
  function closeCase(){ var o=$('rdpCaseOverlay'),m=$('rdpCaseModal'); if(o)o.classList.remove('open'); if(m)m.classList.remove('open'); }
  var cc=$('rdpCaseClose'); if(cc) cc.addEventListener('click', closeCase);
  var co=$('rdpCaseOverlay'); if(co) co.addEventListener('click', closeCase);
  function openCrate(){
    if(spinning || keys<1) return;
    keys--; saveKeys(); renderSpins(); refreshCrateBtns();
    var o=$('rdpCaseOverlay'),m=$('rdpCaseModal'); if(o)o.classList.add('open'); if(m)m.classList.add('open');
    spin();
  }
  if(crateBtn) crateBtn.addEventListener('click', openCrate);
  if(panelBtn) panelBtn.addEventListener('click', openCrate);
  function spin(){
    spinning = true; refreshCrateBtns();
    var reel = $('rdpReel'), result = $('rdpCaseResult');
    if(result) result.textContent = '…';
    var winner = pickPrize();
    var TILES = 42, WIN = 34, STEP = 118;
    if(window.matchMedia('(max-width:768px)').matches) STEP = 100;
    reel.style.transition='none'; reel.style.transform='translateX(0)'; reel.innerHTML='';
    for(var i=0;i<TILES;i++){
      var p = (i===WIN) ? winner : PRIZES[Math.floor(Math.random()*PRIZES.length)];
      var t = document.createElement('div');
      t.className = 'reel-tile r-'+(p.rarity||'milspec');
      var visual = p.image ? '<img src="'+p.image+'" alt="" loading="lazy">' : (p.emoji ? '<span class="reel-emoji" style="font-size:30px;line-height:1;">'+p.emoji+'</span>' : '');
      t.innerHTML = visual + '<span class="pl">'+p.label+'</span>';
      reel.appendChild(t);
    }
    var vp = $('rdpReelViewport').clientWidth;
    var target = WIN*STEP + STEP/2 - 4 - vp/2 + (Math.random()*40 - 20);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      reel.style.transition='transform 5.2s cubic-bezier(.12,.85,.16,1)';
      reel.style.transform='translateX('+(-target)+'px)';
    });});
    reel.addEventListener('transitionend', function onEnd(){
      reel.removeEventListener('transitionend', onEnd);
      spinning = false; refreshCrateBtns();
      var col = rarityColor(winner.rarity);
      if(result){ result.innerHTML =
        '<div style="background:#16202d;border:1px solid '+col+';border-radius:4px;padding:16px;text-align:center;box-shadow:0 0 16px '+col+'33;">'
        + '<div style="font-size:11px;color:#8f98a0;letter-spacing:.5px;margin-bottom:8px;">YOU PULLED</div>'
        + '<div style="font-size:24px;font-weight:800;color:#fff;margin-bottom:10px;">'+(winner.emoji?winner.emoji+' ':'')+winner.label+'</div>'
        + (winner.code?'<div style="display:inline-block;background:#0b0f14;border:1px dashed '+col+';border-radius:3px;padding:9px 22px;font-family:monospace;font-size:16px;font-weight:700;color:'+col+';letter-spacing:2px;">'+winner.code+'</div>':'')
        + (winner.redeem?'<div style="font-size:11.5px;color:#8f98a0;margin-top:12px;">'+winner.redeem+' · one per customer · no stacking</div>':'')
        + '</div>'; }
      addPull(winner);
      toast('📦', winner.label+' won');
    });
  }
  renderSpins();

  /* ---------- real shopify cart ---------- */
  var drawer = $('rdpDrawer'), dOverlay = $('rdpDrawerOverlay');
  function openDrawer()  { if(!drawer) return; drawer.classList.add('open'); if(dOverlay) dOverlay.classList.add('open'); refreshCart(); }
  function closeDrawer(){ drawer.classList.remove('open'); dOverlay.classList.remove('open'); }
  if($('rdpCartClose')){ $('rdpCartClose').addEventListener('click', closeDrawer); dOverlay.addEventListener('click', closeDrawer); }
  if($('rdpCheckoutBtn')){ $('rdpCheckoutBtn').addEventListener('click', function(){ window.location.href = '/checkout'; }); }

  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(renderCart).catch(function(){});
  }
  /* single source of truth for both cart-count badges (header + mobile tab
     bar). Called from renderCart, which already runs after every mutation
     that returns a full cart object (add-then-refetch, change, remove). */
  function syncCartBadges(cart){
    var cc = $('rdpCartCount'); if(cc) cc.textContent = cart.item_count;
    var tb = $('rdpTabBadge');
    if(tb){ if(cart.item_count > 0){ tb.hidden = false; tb.textContent = cart.item_count; } else { tb.hidden = true; } }
  }
  function renderCart(cart){
    syncCartBadges(cart);
    var box = $('rdpCartItems'); if(!box) return;
    $('rdpCartTotal').textContent = fmt(cart.total_price/100);
    if(!cart.items.length){
      box.innerHTML = '<div class="offer-empty">nothing yet. your inventory is empty and that\'s sad</div>';
      return;
    }
    box.innerHTML = '';
    cart.items.forEach(function(it){
      var row = document.createElement('div');
      var _p = (it.price || 0) / 100;
      var _r = _p >= 100 ? 'covert' : _p >= 69 ? 'classified' : _p >= 50 ? 'restricted' : _p >= 25 ? 'milspec' : 'consumer';
      row.className = 'cart-line r-' + _r;
      if (it.url) row.setAttribute('data-rdp-href', it.url);
      row.innerHTML =
        (it.image?'<img src="'+it.image.replace(/(\.[a-z]+)(\?|$)/,'_80x80$1$2')+'" alt="">':'') +
        '<span class="cn"></span>' +
        '<span class="cq"><button class="qty-btn" data-rdp-q="'+(it.quantity-1)+'" data-key="'+it.key+'">−</button> '+it.quantity+
        ' <button class="qty-btn" data-rdp-q="'+(it.quantity+1)+'" data-key="'+it.key+'">+</button></span>' +
        '<span class="cp">'+fmt(it.final_line_price/100)+'</span>';
      row.querySelector('.cn').textContent = it.product_title;
      box.appendChild(row);
    });
  }
  document.addEventListener('click', function(e){
    var add = e.target.closest('[data-rdp-add]');
    if(add){
      add.disabled = true;
      fetch('/cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id: Number(add.getAttribute('data-rdp-add')), quantity: 1})
      }).then(function(r){
        add.disabled = false;
        if(!r.ok) throw 0;
        toast(add.getAttribute('data-emoji') || window.__rdpQuickEmoji || '💊', (add.getAttribute('data-title')||'item')+' added to trade offer');
        openDrawer();
        if(window.rdpMaybeShowFriendRequest) window.rdpMaybeShowFriendRequest();
      }).catch(function(){ add.disabled = false; toast('🫥','could not add — try the product page'); });
    }
    var line = e.target.closest('[data-rdp-href]');
    if (line && !e.target.closest('[data-rdp-q]')) { window.location.href = line.getAttribute('data-rdp-href'); return; }
    var q = e.target.closest('[data-rdp-q]');
    if(q){
      fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id: q.getAttribute('data-key'), quantity: Number(q.getAttribute('data-rdp-q'))})
      }).then(function(r){ return r.json(); }).then(renderCart).catch(function(){});
    }
    /* wishlist hearts */
    var w = e.target.closest('[data-rdp-wish]');
    if(w){
      var h = w.getAttribute('data-rdp-wish');
      var list = []; try{ list = JSON.parse(store.getItem('rdpWish')||'[]'); }catch(err){}
      var i = list.indexOf(h);
      if(i>=0){ list.splice(i,1); w.classList.remove('on'); toast('💔','removed. no refund on the $0.25'); }
      else{ list.push(h); w.classList.add('on'); cappedEarn('wl',5,0.25,'wishlisted an item'); toast('❤️','wishlisted'); }
      try{ store.setItem('rdpWish', JSON.stringify(list)); }catch(err){}
    }
    /* rarity filters */
    var f = e.target.closest('[data-rdp-filter]');
    if(f){
      document.querySelectorAll('[data-rdp-filter]').forEach(function(c){ c.classList.remove('active'); });
      f.classList.add('active');
      var mode = f.getAttribute('data-rdp-filter');
      document.querySelectorAll('#rdp-inventory .item').forEach(function(it){
        var show = mode==='all' ||
          (mode==='instock' && it.getAttribute('data-stock')==='true') ||
          it.getAttribute('data-rarity')===mode;
        it.style.display = show ? '' : 'none';
      });
    }
  });

  /* restore wishlist hearts */
  try{
    JSON.parse(store.getItem('rdpWish')||'[]').forEach(function(h){
      var b = document.querySelector('[data-rdp-wish="'+h+'"]');
      if(b) b.classList.add('on');
    });
  }catch(e){}

  /* esc closes */
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    ['rdpCaseOverlay','rdpCaseModal','rdpClaimOverlay','rdpClaimModal'].forEach(function(id){ var el=$(id); if(el) el.classList.remove('open'); });
    closeDrawer(); if(panel) panel.classList.remove('open');
  });

    renderSpins();
    refreshCart();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();

/* ===== v2: header cart count + quick-add size picker =====
   Badge sync (both #rdpCartCount and #rdpTabBadge) lives in the first
   IIFE's renderCart()/syncCartBadges(), which runs after every cart
   mutation with a full cart object. No separate fetch needed here. */
(function(){
  function $(id){return document.getElementById(id);}
  function closeQuick(){ var m=$('rdpQuickModal'); var o=$('rdpQuickOverlay'); if(m) m.remove(); if(o) o.remove(); }
  function quickAdd(handle, title){
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
      closeQuick();
      var root = document.querySelector('.rdp') || document.body;
      var ov = document.createElement('div'); ov.id='rdpQuickOverlay'; ov.className='modal-overlay quick-overlay open';
      var m = document.createElement('div'); m.id='rdpQuickModal'; m.className='mini-modal open';
      var html = '<h3>pick a size</h3><p>'+(title||p.title)+'</p><div style="display:flex;gap:8px;flex-wrap:wrap;">';
      p.variants.forEach(function(v){
        html += v.available
          ? '<button class="add-btn" style="padding:10px 16px;" data-rdp-add="'+v.id+'" data-title="'+String(p.title+' ('+v.title+')').replace(/"/g,'&quot;')+'">'+v.title+'</button>'
          : '<span class="add-btn" style="opacity:.35;text-decoration:line-through;padding:10px 16px;">'+v.title+'</span>';
      });
      html += '</div><div class="mini-row" style="margin-top:14px;"><button class="btn-ghost" id="rdpQuickClose">never mind</button></div>';
      m.innerHTML = html;
      root.appendChild(ov); root.appendChild(m);
    }).catch(function(){ window.location.href='/products/'+handle; });
  }
  document.addEventListener('click', function(e){
    if(e.target.closest('#rdpCartBtn')){
      var d=$('rdpDrawer');
      if(d){ d.classList.add('open'); var o=$('rdpDrawerOverlay'); if(o) o.classList.add('open'); }
      else window.location.href='/cart';
    }
    if(e.target.closest('#rdpWalletBtn') && !$('rdpWalletPanel')) window.location.href='/#rdp-crates';
    var q=e.target.closest('[data-rdp-quick]');
    if(q) { window.__rdpQuickEmoji = q.getAttribute('data-emoji') || ''; quickAdd(q.getAttribute('data-rdp-quick'), q.getAttribute('data-title') || ''); }
    if(e.target.closest('#rdpQuickClose') || e.target.id==='rdpQuickOverlay') closeQuick();
    if(e.target.closest('#rdpQuickModal') && e.target.closest('[data-rdp-add]')) setTimeout(closeQuick, 150);
  });
})();

/* ===== restock + watch: shared notify plumbing =====
   window.rdpNotifySignup(email, tags) reuses the /contact customer-tag
   POST from the guestbook, remembers the email, and records which tags
   are being watched so buy-box / modal UI can render a confirmed state. */
(function(){
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var rstore = (function(){
    try{ localStorage.setItem('__t','1'); localStorage.removeItem('__t'); return localStorage; }
    catch(e){ var m={}; return {getItem:function(k){return k in m?m[k]:null;},setItem:function(k,v){m[k]=String(v);},removeItem:function(k){delete m[k];}}; }
  })();
  function getWatching(){ try{ return JSON.parse(rstore.getItem('rdp_watching')||'[]'); }catch(e){ return []; } }
  function saveWatching(list){ try{ rstore.setItem('rdp_watching', JSON.stringify(list)); }catch(e){} }

  window.rdpKnownEmail = function(){
    try{ return rstore.getItem('rdp_email') || ''; }catch(e){ return ''; }
  };
  window.rdpIsWatching = function(tag){ return getWatching().indexOf(tag) > -1; };
  window.rdpNotifySignup = function(email, tags){
    email = (email||'').trim().toLowerCase();
    if(!EMAIL_RE.test(email)) return false;
    tags = tags || [];
    var isFriend = tags.indexOf('friend') > -1;
    var body = 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' + encodeURIComponent(email) + '&contact%5Btags%5D=' + encodeURIComponent(tags.join(','));
    try{
      fetch('/contact', {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: body
      }).then(function(r){
      }).catch(function(err){
      });
    }catch(err){
    }
    try{ rstore.setItem('rdp_email', email); }catch(e){}
    var w = getWatching();
    tags.forEach(function(t){ if(w.indexOf(t)===-1) w.push(t); });
    saveWatching(w);
    return true;
  };
})();

/* ===== friend request: SMS drop-alert toast =====
   Fires once ever: waits for the cart notification (#rdpToast) to finish
   hiding, then a further ~1.5s, before showing (falls back to a flat 6s
   delay if the cart toast can't be observed). Triggered from the
   [data-rdp-add] success handler above via window.rdpMaybeShowFriendRequest().
   Reuses the /contact customer POST pattern from rdpNotifySignup, plus a
   contact[phone] field.

   NOTE: this file is included via script_tag from both rdp-header.liquid
   and rdp-crates.liquid, so on pages rendering both sections this whole
   file executes twice. Everything below is guarded by __rdpFriendInit so
   it only wires up once — without this, two independent document click
   listeners fight over the pill's open/close toggle (listener A opens the
   panel, listener B sees it now exists and immediately closes it again). */
(function(){
  if(window.__rdpFriendInit) return;
  window.__rdpFriendInit = true;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var fstore = (function(){
    try{ localStorage.setItem('__t','1'); localStorage.removeItem('__t'); return localStorage; }
    catch(e){ var m={}; return {getItem:function(k){return k in m?m[k]:null;},setItem:function(k,v){m[k]=String(v);},removeItem:function(k){delete m[k];}}; }
  })();

  /* synthesized two-tone notification chime — soft attack, long tails, a
     lowpass -> delay -> convolver-reverb send chain for "room" around it.
     No external audio, no Valve sound assets. */
  function makeImpulse(ctx, duration, decay){
    var rate = ctx.sampleRate;
    var length = Math.max(1, Math.floor(rate * duration));
    var impulse = ctx.createBuffer(2, length, rate);
    for(var ch=0; ch<2; ch++){
      var data = impulse.getChannelData(ch);
      for(var i=0;i<length;i++){ data[i] = (Math.random()*2-1) * Math.exp(-decay*(i/length)); }
    }
    return impulse;
  }
  function playChime(){
    try{
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if(!Ctx) return;
      var ctx = new Ctx();
      var now = ctx.currentTime;

      var master = ctx.createGain();
      master.gain.setValueAtTime(0.12, now);
      master.connect(ctx.destination);

      /* reverb send: dry passthrough + convolver wet mix ~0.18 */
      var reverbDry = ctx.createGain(); reverbDry.gain.setValueAtTime(1, now);
      var reverbSend = ctx.createGain(); reverbSend.gain.setValueAtTime(1, now);
      var reverbWet = ctx.createGain(); reverbWet.gain.setValueAtTime(0.18, now);
      var convolver = ctx.createConvolver();
      convolver.buffer = makeImpulse(ctx, 0.9, 3);
      reverbDry.connect(master);
      reverbSend.connect(convolver); convolver.connect(reverbWet); reverbWet.connect(master);

      /* feedback delay send: ~140ms, feedback 0.28, wet mix ~0.2 */
      var delayDry = ctx.createGain(); delayDry.gain.setValueAtTime(1, now);
      var delaySend = ctx.createGain(); delaySend.gain.setValueAtTime(1, now);
      var delayWet = ctx.createGain(); delayWet.gain.setValueAtTime(0.2, now);
      var delayNode = ctx.createDelay(1.0);
      delayNode.delayTime.setValueAtTime(0.14, now);
      var feedback = ctx.createGain(); feedback.gain.setValueAtTime(0.28, now);
      delayDry.connect(reverbDry); delayDry.connect(reverbSend);
      delaySend.connect(delayNode);
      delayNode.connect(feedback); feedback.connect(delayNode);
      delayNode.connect(delayWet);
      delayWet.connect(reverbDry); delayWet.connect(reverbSend);

      /* gentle lowpass insert ahead of the delay/reverb sends */
      var filter = ctx.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.setValueAtTime(1200, now);
      filter.Q.setValueAtTime(0.7, now);
      filter.connect(delayDry); filter.connect(delaySend);

      /* each note = sine fundamental + sine one octave up at ~25% gain */
      function note(freq, start){
        [[freq,1],[freq*2,0.25]].forEach(function(layer){
          var osc = ctx.createOscillator(), gain = ctx.createGain();
          osc.type = 'sine';
          osc.frequency.setValueAtTime(layer[0], now+start);
          gain.gain.setValueAtTime(0.0001, now+start);
          gain.gain.linearRampToValueAtTime(layer[1], now+start+0.008);
          gain.gain.exponentialRampToValueAtTime(0.0001, now+start+0.008+0.25);
          osc.connect(gain); gain.connect(filter);
          osc.start(now+start); osc.stop(now+start+0.3);
        });
      }
      note(330, 0);
      note(262, 0.15);

      setTimeout(function(){ try{ ctx.close(); }catch(e){} }, 2200);
    }catch(e){}
  }

  function isTestMode(){
    try{ return /(^|[?&])friendtest=1(&|$)/.test(window.location.search||''); }catch(e){ return false; }
  }

  function normalizePhone(raw){
    var stripped = (raw||'').trim().replace(/[\s\-\(\)]/g,'');
    if(stripped.charAt(0) === '+') stripped = stripped.slice(1);
    if(!/^\d{10,15}$/.test(stripped)) return null;
    return stripped.length === 10 ? ('+1'+stripped) : ('+'+stripped);
  }

  /* Steam-style profile picture as the avatar, emoji fallback if it can't be found.
     NOTE: the site header (rdp-header.liquid, .tb-logo) is text-only — no image.
     The actual profile picture is rendered by sections/rdp-hero.liquid as
     <div class="avatar"><img></div> (theme setting `avatar`, or the bundled
     avatar_black.jpg asset if unset). That section only renders on the
     homepage template, so once we find the image there we cache its resolved
     src in localStorage so the toast/pill can use it on every other page too. */
  var logoSrc, logoChecked = false;
  function getLogoSrc(){
    if(logoChecked) return logoSrc;
    logoChecked = true;
    try{ logoSrc = fstore.getItem('rdp_avatar_src') || null; }catch(e){}
    if(logoSrc) return logoSrc;
    var selectors = [
      '.rdp .avatar-wrap .avatar img',
      '.rdp .profile-card .avatar img',
      '.rdp .avatar img',
      'header img[class*="logo" i]',
      'header a[href="/"] img'
    ];
    for(var i=0;i<selectors.length;i++){
      try{
        var el = document.querySelector(selectors[i]);
        if(el && el.tagName === 'IMG' && el.getAttribute('src')) { logoSrc = el.currentSrc || el.src; break; }
      }catch(e){}
    }
    if(logoSrc){ try{ fstore.setItem('rdp_avatar_src', logoSrc); }catch(e){} }
    return logoSrc || null;
  }
  function avatarHTML(){
    var src = getLogoSrc();
    return src ? '<img src="'+src+'" alt="" class="friend-avatar-img">' : '🫂';
  }

  /* shared Steam-notification row: avatar square + title + muted subtitle.
     Reused by the friend-request toast/panel states below, and by the
     generic window.rdpToast() confirmation toast. */
  function toastRowHTML(title, subtitle){
    return '<div class="friend-row">'+
      '<div class="friend-avatar">'+avatarHTML()+'</div>'+
      '<div class="friend-main">'+
        '<div class="friend-name">'+title+'</div>'+
        '<div class="friend-sub">'+subtitle+'</div>'+
      '</div>'+
    '</div>';
  }
  function friendDefaultHTML(){
    return '<button type="button" class="friend-close" aria-label="dismiss">✕</button>'+
      toastRowHTML('rhinodickpill', 'sent you a friend request')+
      '<div class="friend-actions">'+
        '<button type="button" class="btn-blue friend-accept">accept</button>'+
        '<button type="button" class="btn-ghost friend-ignore">ignore</button>'+
      '</div>';
  }
  function friendFormHTML(withDecline){
    var needEmail = !(window.rdpKnownEmail && window.rdpKnownEmail());
    return '<button type="button" class="friend-close" aria-label="dismiss">✕</button>'+
      toastRowHTML('rhinodickpill', 'sent you a friend request')+
      '<div class="friend-form">'+
        (needEmail ? '<input type="email" class="friend-email" placeholder="email">' : '')+
        '<input type="tel" autocomplete="tel" inputmode="tel" class="friend-phone" placeholder="phone number">'+
        '<div class="friend-fine">drops only. no spam. reply STOP to unfriend. msg &amp; data rates may apply.</div>'+
        '<button type="button" class="btn-blue friend-submit">add friend</button>'+
        (withDecline ? '<button type="button" class="friend-decline">decline request</button>' : '')+
      '</div>';
  }
  function friendConfirmedHTML(){
    return '<div class="friend-row">'+
        '<div class="friend-avatar">'+avatarHTML()+'</div>'+
        '<div class="friend-main"><div class="friend-confirmed">✓ friend request accepted — you\'ll hear about drops first</div></div>'+
      '</div>';
  }

  /* ---------- persistent "friends & chat" pill ---------- */
  /* mobile: idle-reveal / scroll-hide. Desktop pill is unaffected — the
     .reveal class only does anything under the mobile media query. */
  function isMobile(){ try{ return window.matchMedia('(max-width:768px)').matches; }catch(e){ return false; } }
  function pillTapped(){ try{ return !!fstore.getItem('rdp_pill_tapped'); }catch(e){ return false; } }
  var pillIdleTimer, pillHideTimer;
  function armPillIdle(){
    if(!isMobile() || pillTapped()) return;
    clearTimeout(pillIdleTimer);
    pillIdleTimer = setTimeout(function(){
      var pill = document.getElementById('rdpFriendPill');
      if(pill && pill.classList.contains('show') && document.visibilityState==='visible' && !pillTapped()){
        pill.classList.add('reveal');
      }
    }, 4000);
  }
  function onPillScroll(){
    if(!isMobile() || pillTapped()) return;
    clearTimeout(pillHideTimer);
    pillHideTimer = setTimeout(function(){
      var pill = document.getElementById('rdpFriendPill');
      if(pill) pill.classList.remove('reveal');
    }, 300);
    armPillIdle();
  }
  window.addEventListener('scroll', onPillScroll, {passive:true});
  document.addEventListener('visibilitychange', function(){ if(document.visibilityState==='visible') armPillIdle(); });

  function syncPill(){
    var pill = document.getElementById('rdpFriendPill');
    if(!pill) return;
    var val = null;
    try{ val = fstore.getItem('rdp_friend'); }catch(e){}
    var toastUp = !!document.getElementById('rdpFriendToast');
    var shouldShow = (val === 'shown' || val === 'ignored') && !toastUp;
    var wasShown = pill.classList.contains('show');
    pill.classList.toggle('show', shouldShow);
    if(!shouldShow) pill.classList.remove('reveal');
    else if(!wasShown) armPillIdle();
  }
  function ensurePill(){
    if(document.getElementById('rdpFriendPill')) return;
    var root = document.querySelector('.rdp') || document.body;
    var p = document.createElement('button');
    p.type = 'button'; p.id = 'rdpFriendPill'; p.className = 'friend-pill';
    p.innerHTML = '<span class="friend-pill-dot"></span>'+
      '<span class="friend-pill-label">1 pending friend request</span>'+
      '<span class="friend-avatar friend-pill-avatar">'+avatarHTML()+'<span class="friend-pill-badge">1</span></span>';
    root.appendChild(p);
    syncPill();
  }
  function openPillPanel(){
    if(document.getElementById('rdpFriendPillPanel')) return;
    var root = document.querySelector('.rdp') || document.body;
    var panel = document.createElement('div');
    panel.id = 'rdpFriendPillPanel'; panel.className = 'friend-toast friend-pill-panel';
    panel.innerHTML = friendFormHTML(true);
    root.appendChild(panel);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ panel.classList.add('show'); }); });
  }
  function closePillPanel(){
    var panel = document.getElementById('rdpFriendPillPanel');
    if(!panel) return;
    panel.classList.remove('show');
    setTimeout(function(){ if(panel.parentNode) panel.parentNode.removeChild(panel); }, 300);
  }

  function dismissToast(t, key){
    if(!isTestMode()){ try{ fstore.setItem('rdp_friend', key); }catch(e){} }
    t.classList.remove('show');
    setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); syncPill(); }, 300);
  }
  function submitFriend(t){
    var emailInput = t.querySelector('.friend-email');
    var phoneInput = t.querySelector('.friend-phone');
    var email = (emailInput ? emailInput.value : (window.rdpKnownEmail ? window.rdpKnownEmail() : '')).trim().toLowerCase();
    var emailOk = EMAIL_RE.test(email);
    var normPhone = normalizePhone(phoneInput ? phoneInput.value : '');
    if(emailInput) emailInput.classList.toggle('invalid', !emailOk);
    if(phoneInput) phoneInput.classList.toggle('invalid', !normPhone);
    if(!emailOk || !normPhone){
      return;
    }
    var digitsOnly = normPhone.replace('+','');
    var tags = ['sms','friend','sms-'+digitsOnly];
    /* Reuses the exact proven rdpNotifySignup(email, tags) path that the
       restock/watch signups already submit through successfully — no
       separate fetch, no custom form body, no contact[phone] field (that
       field isn't one Shopify's default customer /contact form accepts;
       the number survives only via the sms-<digits> tag). */
    var ok = window.rdpNotifySignup(email, tags);
    if(!ok) return;
    if(!isTestMode()){ try{ fstore.setItem('rdp_friend', 'accepted'); }catch(e){} }
    syncPill();
    t.innerHTML = friendConfirmedHTML();
    setTimeout(function(){ dismissToast(t, 'accepted'); }, 3200);
  }

  document.addEventListener('click', function(e){
    var toastEl = document.getElementById('rdpFriendToast');
    var panelEl = document.getElementById('rdpFriendPillPanel');
    var container = (toastEl && toastEl.contains(e.target)) ? toastEl : ((panelEl && panelEl.contains(e.target)) ? panelEl : null);
    if(container){
      if(e.target.closest('.friend-close') || e.target.closest('.friend-ignore')){
        if(container === toastEl) dismissToast(container, 'ignored'); else closePillPanel();
        return;
      }
      if(e.target.closest('.friend-accept')){ container.innerHTML = friendFormHTML(); return; }
      if(e.target.closest('.friend-submit')){ submitFriend(container); return; }
      if(e.target.closest('.friend-decline')){
        if(!isTestMode()){ try{ fstore.setItem('rdp_friend', 'declined'); }catch(err){} }
        closePillPanel();
        syncPill();
        return;
      }
      return;
    }
    if(e.target.closest('#rdpFriendPill')){
      if(!isTestMode()){ try{ fstore.setItem('rdp_pill_tapped', '1'); }catch(err){} }
      clearTimeout(pillIdleTimer); clearTimeout(pillHideTimer);
      if(document.getElementById('rdpFriendPillPanel')) closePillPanel(); else openPillPanel();
      return;
    }
    if(panelEl && !panelEl.contains(e.target)){ closePillPanel(); }
  });

  function showFriendToast(){
    if(document.getElementById('rdpFriendToast')) return;
    var root = document.querySelector('.rdp') || document.body;
    var t = document.createElement('div');
    t.id = 'rdpFriendToast'; t.className = 'friend-toast';
    t.innerHTML = friendDefaultHTML();
    root.appendChild(t);
    if(!isTestMode()){ try{ fstore.setItem('rdp_friend', 'shown'); }catch(e){} }
    syncPill();
    playChime();
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ t.classList.add('show'); }); });
  }

  /* generic confirmation toast — same shell as the friend-request toast
     (position, gradient, border, slide-up entrance), but self-contained:
     no buttons, no sound, auto-dismisses after ~4s. Reuses .friend-toast
     so it's already above the inspect modal (z-index 310 vs 241) and the
     mobile "above the tab bar" positioning comes for free. Independent of
     #rdpFriendToast — does not touch the friend-request flag/pill logic. */
  function rdpToast(opts){
    opts = opts || {};
    var existing = document.getElementById('rdpGenericToast');
    if(existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var root = document.querySelector('.rdp') || document.body;
    var t = document.createElement('div');
    t.id = 'rdpGenericToast'; t.className = 'friend-toast rdp-toast-auto';
    t.innerHTML = toastRowHTML(opts.title||'', opts.subtitle||'');
    root.appendChild(t);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ t.classList.add('show'); }); });
    setTimeout(function(){
      t.classList.remove('show');
      setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); }, 300);
    }, 4000);
    return t;
  }
  window.rdpToast = rdpToast;

  function pathBlocked(){ return /^\/(cart|checkout)(\/|$)/.test(window.location.pathname||''); }
  function eligible(){
    try{ if(fstore.getItem('rdp_friend')) return false; }catch(e){}
    return !pathBlocked();
  }

  function initFriendUI(){
    ensurePill();
    if(isTestMode()){
      setTimeout(function(){ if(!pathBlocked()) showFriendToast(); }, 1500);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', initFriendUI); else initFriendUI();

  window.rdpMaybeShowFriendRequest = function(){
    if(!eligible()) return;
    var cartToast = document.getElementById('rdpToast');
    if(!cartToast || !window.MutationObserver){
      setTimeout(function(){ if(eligible()) showFriendToast(); }, 6000);
      return;
    }
    if(!cartToast.classList.contains('show')){
      setTimeout(function(){ if(eligible()) showFriendToast(); }, 1500);
      return;
    }
    var done = false;
    var backstop = setTimeout(function(){
      if(done) return;
      done = true; mo.disconnect();
      if(eligible()) showFriendToast();
    }, 8000);
    var mo = new MutationObserver(function(){
      if(done || cartToast.classList.contains('show')) return;
      done = true; mo.disconnect(); clearTimeout(backstop);
      setTimeout(function(){ if(eligible()) showFriendToast(); }, 1500);
    });
    mo.observe(cartToast, {attributes:true, attributeFilter:['class']});
  };
})();

/* ===== v3: inspect modal + product page wiring ===== */
(function(){
  function $(id){ return document.getElementById(id); }
  var RC = {consumer:'#b0c3d9',milspec:'#4b69ff',restricted:'#8847ff',classified:'#d32ce6',covert:'#eb4b4b',gold:'#e4ae39'};
  var RN = {consumer:'consumer grade',milspec:'mil-spec',restricted:'restricted',classified:'classified',covert:'covert',gold:'★ contraband'};

  /* ---------- real Judge.me reviews ----------
     sections/rdp-inventory.liquid and sections/rdp-featured.liquid each emit a
     <script class="rdp-reviews-data" type="application/json"> containing a
     {handle: [{author,body,score,verified}, ...]} map, parsed server-side from
     the judgeme.widget metafield by snippets/rdp-reviews-json.liquid. */
  var reviewsDataCache = null;
  function reviewsData(){
    if(reviewsDataCache) return reviewsDataCache;
    var map = {};
    document.querySelectorAll('script.rdp-reviews-data').forEach(function(el){
      try{
        var obj = JSON.parse(el.textContent);
        for(var k in obj){ if(Object.prototype.hasOwnProperty.call(obj, k)) map[k] = obj[k]; }
      }catch(e){}
    });
    reviewsDataCache = map;
    return map;
  }
  var lastReviewPick = {};
  function pickEligibleReview(handle, pool){
    if(pool.length === 1){ lastReviewPick[handle] = 0; return pool[0]; }
    var prev = lastReviewPick[handle];
    var idx;
    do{ idx = Math.floor(Math.random()*pool.length); }while(idx === prev);
    lastReviewPick[handle] = idx;
    return pool[idx];
  }
  function starsHTML(score){
    var s = '';
    for(var i=0;i<5;i++){ s += (i<score ? '★' : '☆'); }
    return '<span class="rv-stars" aria-label="'+score+' out of 5 stars">'+s+'</span>';
  }
  function reviewBlockHTML(handle, p){
    var all = reviewsData()[handle] || [];
    if(!all.length){
      var head, sub;
      var createdMs = p && p.created_at ? new Date(p.created_at).getTime() : NaN;
      var isRecent = !isNaN(createdMs) && (Date.now() - createdMs) <= (30*24*60*60*1000);
      if(isRecent && p && p.available === true){
        head = 'NEW · recently added to inventory';
        sub = 'no player reviews yet — be the first on record →';
      } else if(p && p.available === false){
        head = 'RETIRED · no reviews on record';
        sub = 'add one anyway →';
      } else {
        head = 'NO REVIEWS ON RECORD';
        sub = 'be the first on record →';
      }
      return '<div class="inspect-review inspect-review--empty">'+
        '<div class="rv-empty-head"><span class="rv-empty-icon">🆕</span>'+head+'</div>'+
        '<a class="rv-empty-link" href="/products/'+handle+'#judgeme_product_reviews">'+sub+'</a>'+
      '</div>';
    }
    var eligible = all.filter(function(r){ return r.score >= 4; });
    if(!eligible.length) return '';
    var verified = eligible.filter(function(r){ return r.verified; });
    var pool = verified.length ? verified : eligible;
    var pick = pickEligibleReview(handle, pool);
    var countHTML = pool.length > 1 ? '<div class="rv-count">'+(pool.indexOf(pick)+1)+' of '+pool.length+'</div>' : '';
    return '<div class="inspect-review">'+
      '<div class="rv-head">👍 <span class="rv-rec">Recommended</span> · '+starsHTML(pick.score)+'</div>'+
      '<div class="rv-body">'+pick.body+'</div>'+
      '<div class="rv-foot">— '+pick.author+(pick.verified ? ' <span class="rv-verified" title="verified buyer">✓ verified</span>' : '')+'</div>'+
      countHTML+
    '</div>';
  }
  function rarityOf(p){
    for(var i=0;i<(p.tags||[]).length;i++){
      var t = p.tags[i];
      if(t.indexOf('rarity:')===0) return t.replace('rarity:','').trim();
    }
    var d = p.price/100;
    if(d>=100) return 'covert';
    if(d>=69) return 'classified';
    if(d>=50) return 'restricted';
    if(d>=25) return 'milspec';
    return 'consumer';
  }
  function sparkSVG(price){
    var pts=[], v=price*0.8;
    for(var i=0;i<24;i++){ v=Math.max(price*0.4, v+(Math.random()-0.45)*price*0.08); pts.push(v); }
    pts.push(price);
    var max=Math.max.apply(null,pts), min=Math.min.apply(null,pts);
    var poly=pts.map(function(p,i){ return ((i/(pts.length-1))*256+2)+','+(58-((p-min)/(max-min||1))*50); }).join(' ');
    return '<polyline points="'+poly+'" fill="none" stroke="#66c0f4" stroke-width="2"/>';
  }
  function money(cents){ return '$'+(cents/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function imgUrl(u, w){ return u + (u.indexOf('?')>-1?'&':'?') + 'width=' + w; }
  function tilt(stage, img){
    stage.addEventListener('pointermove', function(e){
      var r = stage.getBoundingClientRect();
      var x = (e.clientX-r.left)/r.width - .5, y = (e.clientY-r.top)/r.height - .5;
      img.style.transform = 'rotateY('+(x*24)+'deg) rotateX('+(-y*24)+'deg) scale(1.05)';
    });
    stage.addEventListener('pointerleave', function(){ img.style.transform=''; });
  }

  /* ---------- restock alert (buy box) + watch row (inspect modal) ---------- */
  function handleize(s){ return (s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  function restockTags(handle, size){
    var t = ['restock', 'restock-'+handle];
    if(size) t.push('restock-'+handle+'-'+size);
    return t;
  }
  function restockKey(handle, size){ return size ? ('restock-'+handle+'-'+size) : ('restock-'+handle); }
  function renderRestockPanel(panel, handle, size, sizeLabel){
    if(!panel) return;
    panel.hidden = false;
    panel.setAttribute('data-active-handle', handle);
    panel.setAttribute('data-active-size', size||'');
    panel.setAttribute('data-active-size-label', sizeLabel||'');
    var label = 'restock alert' + (size ? ' — size '+sizeLabel : '');
    if(window.rdpIsWatching && window.rdpIsWatching(restockKey(handle, size))){
      panel.innerHTML = '<div class="restock-label">'+label+'</div><div class="restock-confirmed">✓ watching — we\'ll email you once</div>';
      return;
    }
    var email = (window.rdpKnownEmail && window.rdpKnownEmail()) || '';
    panel.innerHTML =
      '<div class="restock-label">'+label+'</div>'+
      '<div class="restock-row"><input type="email" class="restock-email" placeholder="your email" value="'+String(email).replace(/"/g,'&quot;')+'">'+
      '<button type="button" class="btn-blue restock-btn">notify me</button></div>'+
      '<div class="restock-sub">one email when it\'s back. that\'s it.</div>';
  }
  function watchTags(handle, soldOut){
    var t = ['watch', 'watch-'+handle];
    if(soldOut){ t.push('restock'); t.push('restock-'+handle); }
    return t;
  }
  /* same glyph as the sold-out tile chip (.soldout-eye) — ties the two together */
  var EYE_SVG = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z"/><circle cx="12" cy="12" r="3"/></svg>';
  var EYE_ICON = '<span class="insp-watch-icon">'+EYE_SVG+'</span>';
  function renderWatchRow(row, handle, soldOut){
    if(!row) return;
    var watching = window.rdpIsWatching && window.rdpIsWatching('watch-'+handle);
    row.classList.toggle('on', !!watching);
    if(watching){
      row.innerHTML = '<span class="insp-watch-left">'+EYE_ICON+'<span class="insp-watch-label">✓ watching</span></span><span class="insp-watch-hint">restocks + drops</span>';
    } else {
      row.innerHTML = '<button type="button" class="insp-watch-toggle"><span class="insp-watch-left">'+EYE_ICON+'<span class="insp-watch-label">watch this item</span></span><span class="insp-watch-hint">restocks + drops</span></button>';
    }
  }

  /* ---------- inspect modal ---------- */
  var inspImgs = [], inspIdx = 0;
  function closeInsp(){
    var m=$('rdpInspModal'), o=$('rdpInspOverlay');
    if(m) m.remove(); if(o) o.remove();
    document.body.classList.remove('rdp-modal-open');
  }
  function showInspImg(i){
    if(!inspImgs.length) return;
    inspIdx = (i+inspImgs.length)%inspImgs.length;
    var img = $('rdpInspImg');
    if(img) img.src = imgUrl(inspImgs[inspIdx], 900);
    var dots = document.querySelectorAll('.insp-dot');
    dots.forEach(function(d,di){ d.classList.toggle('sel', di===inspIdx); });
  }
  function openInspect(handle){
    fetch('/products/'+handle+'.js').then(function(r){ return r.json(); }).then(function(p){
      closeInsp();
      inspImgs = p.images || []; inspIdx = 0;
      var r = rarityOf(p);
      var root = document.querySelector('.rdp') || document.body;
      var ov = document.createElement('div'); ov.id='rdpInspOverlay'; ov.className='modal-overlay open';
      var m = document.createElement('div'); m.id='rdpInspModal'; m.className='inspect-modal';
      var multi = inspImgs.length > 1;
      var addBtn = p.available
        ? (p.variants.length===1
            ? '<button class="btn-green" data-rdp-add="'+p.variants[0].id+'" data-title="'+p.title.replace(/"/g,'&quot;')+'">add to trade offer</button>'
            : '<button class="btn-green" data-rdp-quick="'+handle+'" data-title="'+p.title.replace(/"/g,'&quot;')+'">add to trade offer</button>')
        : '';
      var showWatch = !p.available || (p.variants||[]).some(function(v){ return !v.available; });
      m.innerHTML =
        '<div class="inspect-stage" id="rdpInspStage">'+
          (inspImgs.length?'<img id="rdpInspImg" src="'+imgUrl(inspImgs[0],900)+'" alt="">':'')+
          (multi?'<button class="insp-arrow insp-prev" id="rdpInspPrev">‹</button><button class="insp-arrow insp-next" id="rdpInspNext">›</button>':'')+
          (multi?'<div class="insp-dots">'+inspImgs.map(function(_,i){return '<button class="insp-dot'+(i===0?' sel':'')+'" data-rdp-dot="'+i+'"></button>';}).join('')+'</div>':'')+
        '</div>'+
        '<div class="inspect-info">'+
          '<button class="inspect-close" id="rdpInspClose">✕</button>'+
          '<span class="rarity-tag" style="background:'+RC[r]+'22;color:'+RC[r]+';border:1px solid '+RC[r]+'66;">'+(r==='covert'||r==='gold'?'★ ':'')+RN[r]+'</span>'+
          '<h3>'+p.title+'</h3>'+
          '<div class="inspect-meta">exterior: factory new · float: '+(Math.random()*0.01).toFixed(6)+' · '+(p.available?'this item is marketable':'no longer marketable. it\'s over')+'</div>'+
          '<svg class="spark" viewBox="0 0 260 64" preserveAspectRatio="none">'+sparkSVG(p.price/100)+'</svg>'+
          '<div class="spark-label">median price sold (this chart is decorative and emotionally true)</div>'+
          '<div class="inspect-pricerow"><span class="price-big">'+money(p.price)+'</span>'+addBtn+'</div>'+
          '<a class="insp-link" href="/products/'+handle+'">view full item page →</a>'+
          reviewBlockHTML(handle, p)+
        '</div>'+
        (showWatch ? '<div class="insp-watch" id="rdpInspWatch" data-handle="'+handle+'" data-sold-out="'+(p.available?'':'1')+'"></div>' : '');
      root.appendChild(ov); root.appendChild(m);
      document.body.classList.add('rdp-modal-open');
      var st=$('rdpInspStage'), im=$('rdpInspImg');
      if(st && im) tilt(st, im);
      if(showWatch) renderWatchRow($('rdpInspWatch'), handle, !p.available);
    }).catch(function(){ window.location.href = '/products/'+handle; });
  }

  document.addEventListener('click', function(e){
    var thumb = e.target.closest('[data-rdp-thumb]');
    if(thumb){
      var ppimg = document.getElementById('rdpPPImg');
      if(ppimg) ppimg.src = thumb.getAttribute('data-rdp-thumb');
      if(ppimg) ppimg.setAttribute('data-zoom', thumb.getAttribute('data-rdp-thumb'));
      document.querySelectorAll('.pp-thumb').forEach(function(x){ x.classList.remove('sel'); });
      thumb.classList.add('sel');
      return;
    }
    var insp = e.target.closest('[data-rdp-inspect]');
    if(insp && !e.target.closest('[data-rdp-wish]')){
      e.preventDefault();
      openInspect(insp.getAttribute('data-rdp-inspect'));
      return;
    }
    if(e.target.closest('#rdpInspClose') || e.target.id==='rdpInspOverlay') closeInsp();
    if(e.target.closest('#rdpInspPrev')) showInspImg(inspIdx-1);
    if(e.target.closest('#rdpInspNext')) showInspImg(inspIdx+1);
    var dot = e.target.closest('[data-rdp-dot]');
    if(dot) showInspImg(Number(dot.getAttribute('data-rdp-dot')));
    if(e.target.closest('#rdpInspModal') && e.target.closest('[data-rdp-add]')) setTimeout(closeInsp, 150);

    /* buy-box restock alert signup */
    var rbtn = e.target.closest('.restock-btn');
    if(rbtn){
      var rpanel = rbtn.closest('.pp-restock');
      if(rpanel){
        var rhandle = rpanel.getAttribute('data-active-handle');
        var rsize = rpanel.getAttribute('data-active-size');
        var rsizeLabel = rpanel.getAttribute('data-active-size-label');
        var remail = rpanel.querySelector('.restock-email');
        if(window.rdpNotifySignup(remail ? remail.value : '', restockTags(rhandle, rsize))){
          renderRestockPanel(rpanel, rhandle, rsize, rsizeLabel);
          if(window.rdpToast) window.rdpToast({title:'✓ restock alert set', subtitle:'we\'ll email you once when it\'s back'});
        }
      }
      return;
    }

    /* inspect modal watch row */
    var wtoggle = e.target.closest('.insp-watch-toggle');
    if(wtoggle){
      var wrow = wtoggle.closest('.insp-watch');
      if(wrow){
        var whandle = wrow.getAttribute('data-handle');
        var wsoldOut = wrow.getAttribute('data-sold-out') === '1';
        var wemail = window.rdpKnownEmail && window.rdpKnownEmail();
        if(wemail){
          window.rdpNotifySignup(wemail, watchTags(whandle, wsoldOut));
          renderWatchRow(wrow, whandle, wsoldOut);
          if(window.rdpToast) window.rdpToast({title:'✓ now watching', subtitle:'restocks + drops'});
        } else {
          wrow.innerHTML =
            '<div class="restock-row insp-watch-form">'+
              '<input type="email" class="restock-email insp-watch-email" placeholder="your email">'+
              '<button type="button" class="btn-blue insp-watch-confirm">notify me</button>'+
            '</div>';
        }
      }
      return;
    }
    var wconfirm = e.target.closest('.insp-watch-confirm');
    if(wconfirm){
      var wrow2 = wconfirm.closest('.insp-watch');
      if(wrow2){
        var whandle2 = wrow2.getAttribute('data-handle');
        var wsoldOut2 = wrow2.getAttribute('data-sold-out') === '1';
        var wemailInput = wrow2.querySelector('.insp-watch-email');
        if(window.rdpNotifySignup(wemailInput ? wemailInput.value : '', watchTags(whandle2, wsoldOut2))){
          renderWatchRow(wrow2, whandle2, wsoldOut2);
          if(window.rdpToast) window.rdpToast({title:'✓ now watching', subtitle:'restocks + drops'});
        }
      }
      return;
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape') closeInsp();
    if($('rdpInspModal')){
      if(e.key==='ArrowLeft') showInspImg(inspIdx-1);
      if(e.key==='ArrowRight') showInspImg(inspIdx+1);
    }
  });

  /* ---------- product page wiring ---------- */
  function ppInit(){
    /* random float values */
    document.querySelectorAll('[data-rdp-float]').forEach(function(el){ el.textContent = (Math.random()*0.01).toFixed(6); });
    /* variant pills sync the add button + the payment form */
    document.querySelectorAll('[data-rdp-variant]').forEach(function(b){
      b.addEventListener('click', function(){
        if(b.classList.contains('out')){
          var panel = $('rdpRestockPanel');
          if(panel){
            var handle = panel.getAttribute('data-handle');
            var sizeLabel = b.textContent.trim();
            renderRestockPanel(panel, handle, handleize(sizeLabel), sizeLabel);
          }
          return;
        }
        document.querySelectorAll('[data-rdp-variant]').forEach(function(x){ x.classList.remove('sel'); });
        b.classList.add('sel');
        var vid = b.getAttribute('data-rdp-variant');
        var add = $('rdpPPAdd');
        if(add){ add.setAttribute('data-rdp-add', vid); add.textContent = 'add to trade offer — '+b.getAttribute('data-price'); }
        var f = $('rdpFormVariant'); if(f) f.value = vid;
        document.querySelectorAll('.pp-sticky [data-rdp-add]').forEach(function(s){ s.setAttribute('data-rdp-add', vid); });
        var rpanel = $('rdpRestockPanel');
        if(rpanel) rpanel.hidden = true;
      });
    });
    /* restock panel initial state */
    (function(){
      var panel = $('rdpRestockPanel');
      if(!panel) return;
      var handle = panel.getAttribute('data-handle');
      var sized = panel.getAttribute('data-sized') === 'true';
      var prodAvail = panel.getAttribute('data-product-available') === 'true';
      var curAvail = panel.getAttribute('data-cur-available') === 'true';
      var curSize = panel.getAttribute('data-cur-size');
      var curSizeLabel = panel.getAttribute('data-cur-size-label');
      if(!prodAvail){
        renderRestockPanel(panel, handle, '', '');
      } else if(!curAvail && sized){
        renderRestockPanel(panel, handle, curSize, curSizeLabel);
      }
    })();
    /* spark chart */
    var sp=$('rdpPPSpark');
    if(sp) sp.innerHTML = sparkSVG(Number(sp.getAttribute('data-price'))||50);
    /* sticky bar on scroll */
    var sticky=$('rdpPPSticky'), add=$('rdpPPAdd');
    if(sticky && add && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        sticky.classList.toggle('show', !entries[0].isIntersecting);
      }, {rootMargin:'-60px 0px 0px 0px'}).observe(add);
    }
    /* measure real nav-bar height so the trade bar sits exactly above it */
    (function(){
      function syncTabbarH(){
        var tb=document.querySelector('.rdp-tabbar');
        var h=(tb && getComputedStyle(tb).display!=='none') ? tb.offsetHeight : 0;
        document.documentElement.style.setProperty('--rdp-tabbar-h', h+'px');
      }
      syncTabbarH();
      window.addEventListener('resize', syncTabbarH);
      window.addEventListener('orientationchange', syncTabbarH);
      if(window.visualViewport) window.visualViewport.addEventListener('resize', syncTabbarH);
    })();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', ppInit); else ppInit();
})();

/* ===== v5: product image zoom lightbox ===== */
(function(){
  function gallery(){
    var thumbs = document.querySelectorAll('[data-rdp-thumb]');
    if(thumbs.length) return Array.prototype.map.call(thumbs, function(t){ return t.getAttribute('data-rdp-thumb'); });
    var main = document.getElementById('rdpPPImg');
    return main ? [main.getAttribute('data-zoom')||main.src] : [];
  }
  var zi = 0;
  function openZoom(src){
    var imgs = gallery();
    zi = Math.max(0, imgs.indexOf(src));
    var ov = document.createElement('div'); ov.className='rdp-zoom-overlay open'; ov.id='rdpZoom';
    var multi = imgs.length > 1;
    ov.innerHTML = '<button class="rdp-zoom-close" id="rdpZoomClose">✕</button>'+
      (multi?'<button class="rdp-zoom-nav rdp-zoom-prev" id="rdpZoomPrev">‹</button><button class="rdp-zoom-nav rdp-zoom-next" id="rdpZoomNext">›</button>':'')+
      '<img id="rdpZoomImg" src="'+(imgs[zi]||src)+'" alt="">';
    document.body.appendChild(ov);
  }
  function setZoom(i){
    var imgs = gallery(); if(!imgs.length) return;
    zi = (i+imgs.length)%imgs.length;
    var im = document.getElementById('rdpZoomImg'); if(im) im.src = imgs[zi];
  }
  function closeZoom(){ var z=document.getElementById('rdpZoom'); if(z) z.remove(); }
  document.addEventListener('click', function(e){
    if(e.target.id==='rdpPPImg'){ openZoom(e.target.getAttribute('data-zoom')||e.target.src); return; }
    if(e.target.id==='rdpZoomClose' || e.target.id==='rdpZoom'){ closeZoom(); return; }
    if(e.target.id==='rdpZoomPrev'){ setZoom(zi-1); return; }
    if(e.target.id==='rdpZoomNext'){ setZoom(zi+1); return; }
  });
  document.addEventListener('keydown', function(e){
    if(!document.getElementById('rdpZoom')) return;
    if(e.key==='Escape') closeZoom();
    if(e.key==='ArrowLeft') setZoom(zi-1);
    if(e.key==='ArrowRight') setZoom(zi+1);
  });
})();

/* ===== v12: mobile tab bar cart wiring =====
   #rdpTabBadge sync also lives in syncCartBadges() (first IIFE) now — it
   runs after every mutation via renderCart(), same as #rdpCartCount. */
(function(){
  function $(id){return document.getElementById(id);}
  document.addEventListener('click', function(e){
    if(e.target.closest('#rdpTabCart')){
      var d=$('rdpDrawer');
      if(d){ d.classList.add('open'); var o=$('rdpDrawerOverlay'); if(o) o.classList.add('open'); }
      else window.location.href='/cart';
    }
  });
})();

/* ===== v13: sold-out to bottom; in-stock order comes from the manual collection ===== */
(function(){
  function sortInv(){
    var grid = document.querySelector('#rdp-inventory .inv-grid');
    if(!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.item'));
    items.sort(function(a,b){
      var sa = a.getAttribute('data-stock')==='true' ? 0 : 1;
      var sb = b.getAttribute('data-stock')==='true' ? 0 : 1;
      return sa - sb;
    });
    items.forEach(function(it){ grid.appendChild(it); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', sortInv); else sortInv();
})();
